import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useCreateGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ name, type, parentGroupId }) => authAPI.createGroup({ name, type, parentGroupId }),
    {
      onSuccess: () => {
        // Invalidate group tree queries
        queryClient.invalidateQueries(["group"]);
        // Invalidate organizations
        queryClient.invalidateQueries(["organizations"]);
      },
      onError: (error) => {
        console.error("Error while creating group:", error);
      },
    }
  );
};
